import { useTranslation } from 'react-i18next';
import { useCreateBackup } from '@/hooks/backup';
import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { Icon } from '@iconify/react';
import { toast } from 'sonner';

const BackupSettings = () => {
  const { t } = useTranslation();
  const { mutate: createBackup, isPending } = useCreateBackup();

  const handleCreateBackup = () => {
    createBackup(undefined, {
      onSuccess: () => {
        toast.success(t('backup.success') || 'Backup created and downloaded successfully');
      },
      onError: (error) => {
        toast.error(
          t('backup.error') || `Failed to create backup: ${error.message || 'Unknown error'}`
        );
      },
    });
  };

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-2xl font-semibold">
          {t('backup.title') || 'Backup'}
        </h1>
        <p className="text-muted-foreground mt-2">
          {t('backup.description') || 'Create a backup of your database and MinIO files'}
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>{t('backup.createBackup') || 'Create Backup'}</CardTitle>
          <CardDescription>
            {t('backup.createBackupDescription') ||
              'Download a complete backup of your system including the database and all MinIO files'}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div className="flex items-start space-x-4">
              <Icon
                icon="material-symbols:info-outline"
                className="w-5 h-5 text-blue-500 mt-0.5 flex-shrink-0"
              />
              <div className="space-y-2 text-sm text-muted-foreground">
                <p>
                  {t('backup.info') ||
                    'The backup will include:'}
                </p>
                <ul className="list-disc list-inside space-y-1 ml-2">
                  <li>{t('backup.includesDatabase') || 'PostgreSQL database dump'}</li>
                  <li>{t('backup.includesMinIO') || 'All files from MinIO storage (private and public buckets)'}</li>
                </ul>
              </div>
            </div>

            <Button
              onClick={handleCreateBackup}
              disabled={isPending}
              className="w-full sm:w-auto"
            >
              {isPending ? (
                <>
                  <Icon
                    icon="svg-spinners:ring-resize"
                    className="w-4 h-4 mr-2"
                  />
                  {t('backup.creating') || 'Creating Backup...'}
                </>
              ) : (
                <>
                  <Icon icon="material-symbols:download" className="w-4 h-4 mr-2" />
                  {t('backup.createButton') || 'Create Backup'}
                </>
              )}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default BackupSettings;


